import { lazy } from "react";

export { ASSETS_LIST_PATH } from "./assets-list-path";
export const AssetsListPage = lazy(() => import("./assets-list"));
